<template>
  <div>
    <b>Reference</b>
    <ol id="ref">
      <li>
        <a
          href="https://kc-hospital.net/sites/default/files/%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B9%80%E0%B8%81%E0%B8%A5%E0%B8%B7%E0%B8%AD.pdf"
          >แนวทางการเตรียมสารน้ำชนิด Dextrose
          ในความเข้มนอกเหนือที่มีในบัญชียาโรงพยาบาล</a
        >
      </li>
      <li>
        <a
          href="https://www.competencyrx.com/index.php/%E0%B9%80%E0%B8%A0%E0%B8%AA%E0%B8%B1%E0%B8%8A%E0%B8%81%E0%B8%A3%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%B3%E0%B8%99%E0%B8%A7%E0%B8%93/60-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%84%E0%B8%B3%E0%B8%99%E0%B8%A7%E0%B8%93%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B8%A5%E0%B8%B0%E0%B8%A5%E0%B8%B2%E0%B8%A2"
          >การคำนวณสารละลาย</a
        >
      </li>
      <li>
        <a
          href="https://www.facebook.com/permalink.php?id=1727634260696269&story_fbid=1810625365730491"
          >เทคนิคการแก้ระบบสมการเชิงเส้นสองตัวแปร</a
        >
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "ref",
};
</script>

<style scoped>
ol#ref li {
  display: list-item;
}
a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: #0e4b91;
}
</style>
